module.exports = __webpack_public_path__ + "static/6676783_orig-0d40b0022636469bf12a5b334c1ff0cb.jpg";